import {
  POST_OTP_REQUEST,
  POST_OTP_SUCCESS,
  POST_OTP_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POST_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case POST_OTP_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case POST_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
